import {
  AD_DETAIL_RESERVATION_HASHES as sharedAdDetailReservationHashes,
  PAGE_NAMES_BY_LISTING_SECTION_ID as sharedPageNamesByListingSectionId
} from '../common/page.js'
import {
  BUGGIES_CATEGORY1_ID,
  CLASSICS_CATEGORY1_ID,
  FUEL_TYPE_CNG_ID,
  FUEL_TYPE_DIESEL_ID,
  FUEL_TYPE_ELECTRIC_ID,
  FUEL_TYPE_GASOLINE_ID,
  FUEL_TYPE_GLP_ID,
  FUEL_TYPE_HYBRID_ID,
  FUEL_TYPE_HYBRID_PLUG_IN_ID,
  MINIMOTOS_CATEGORY1_ID,
  MOTOS_CATEGORY1_ID,
  QUADS_CATEGORY1_ID
} from './ads.js'
import {VEHICLE_STATE_IDS} from './subscription.js'

export const VEHICLE_STATE_ID_SLUG_MAPPING = {
  [VEHICLE_STATE_IDS.NEW]: 'nuevo',
  [VEHICLE_STATE_IDS.USED]: 'segunda-mano'
}

export const FUEL_TYPE_ID_SLUG_MAPPING = {
  [FUEL_TYPE_CNG_ID]: 'gas_natural',
  [FUEL_TYPE_DIESEL_ID]: 'diesel',
  [FUEL_TYPE_ELECTRIC_ID]: 'electrico',
  [FUEL_TYPE_GASOLINE_ID]: 'gasolina',
  [FUEL_TYPE_GLP_ID]: 'gas_glp',
  [FUEL_TYPE_HYBRID_ID]: 'hibrido',
  [FUEL_TYPE_HYBRID_PLUG_IN_ID]: 'hibrido_enchufable'
}

export const SECTION_ID_MAPPING = {
  [MOTOS_CATEGORY1_ID]: 'bikes',
  [QUADS_CATEGORY1_ID]: 'quads',
  [CLASSICS_CATEGORY1_ID]: 'classics',
  [BUGGIES_CATEGORY1_ID]: 'buggies',
  [MINIMOTOS_CATEGORY1_ID]: 'minimotos'
}

export const PAGINATION_PATTERN = 'pg='
export const QUERY_SEARCH_PATTERN = 'q='
export const QUESTION_MARK = '?'
export const AMPERSAND_MARK = '&'
export const WILDCARD_MARK = '*'
export const PARAMS_PATTERN = `[${QUESTION_MARK}|${AMPERSAND_MARK}]`

export const HOME_PATH_PATTERN = '/'
export const AB_HOME_PATH_PATTERN = '/home.htm'

export const LOGIN_PATH_PATTERN = '/login'
export const LOGIN_WITH_LOGIN_SCREEN_PATH_PATTERN = `${LOGIN_PATH_PATTERN}/?p=l`
export const LOGIN_WITH_REGISTER_SCREEN_PATH_PATTERN = `${LOGIN_PATH_PATTERN}/?p=r`
export const AB_LOGIN_PATH_PATTERN = '/login.htm'

export const TERMS_OF_SERVICE_PATH_PATTERN = '/condiciones-de-uso'
export const TRANSPARENCY_PATH_PATTERN = '/transparencia/'
export const DATA_PROTECTION_PATH_PATTERN = `${TERMS_OF_SERVICE_PATH_PATTERN}/#proteccion-datos`
export const SORT_MANAGEMENT_TERMS_PATH_PATTERN = `${TERMS_OF_SERVICE_PATH_PATTERN}/#criterios-ordenacion`
export const OTHER_PARTNERS_PATH_PATTERN = '/cookies-otros-partners'

export const PTA_PATH_PATTERN = '/vender-mi-moto'
export const PTA_WITH_PLATE_PATH_PATTERN = '/publicar-mi-anuncio/categoria'
export const PTA_OTHER_CATEGORIES_PATH_PATTERN = '/Vender-mi-moto.aspx'
export const PRODUCTS_PATH_PATTERN = '/products/'

export const INSTANT_OFFER_SELL_TO_DEALER_PATTERN = '/vende-a-profesional'
export const INSTANT_OFFER_STANDALONE_PATTERN = '/vender-mi-moto-a-un-profesional'

export const INSURANCE_PATH = '/seguros'

export const MOBILE_PAGES_PATH_PATTERN = '/mobile'

export const ADS_LIST_SEARCH_PATH_PATTERN = '/search/'

export const SECOND_HAND_PATH_PATTERN = '/segunda-mano/'

export const ADS_LIST_SEMANTIC_PRIVATE_SELLER = 'ads-list-semantic-private-seller'
export const ADS_LIST_SEMANTIC_ELECTRIC = 'ads-list-semantic-electric'

export const ADS_LIST_SEMANTIC_ELECTRIC_REGEX = /electricas/
export const ADS_LIST_SEMANTIC_PRIVATE_SELLER_REGEX = /particulares/

export const ADS_LIST_SEMANTIC_REGEXS = {
  [ADS_LIST_SEMANTIC_ELECTRIC]: ADS_LIST_SEMANTIC_ELECTRIC_REGEX,
  [ADS_LIST_SEMANTIC_PRIVATE_SELLER]: ADS_LIST_SEMANTIC_PRIVATE_SELLER_REGEX
}

export const ADS_LIST_SUBSCRIPTION_PATH_PATTERN = '/renting/'
export const ADS_LIST_SUBSCRIPTION_PATH_PATTERN_WITH_REGEX = /^\/renting(\/)?([A-z0-9\-&]*)(\/)?([A-z0-9\-&]*)(\/)?$/

export const ADS_LIST_PATH_PATTERNS = {
  [MOTOS_CATEGORY1_ID]: [SECOND_HAND_PATH_PATTERN, '/nuevas/'],
  [QUADS_CATEGORY1_ID]: [`${SECOND_HAND_PATH_PATTERN}quads/`, '/nuevas/quads/'],
  [BUGGIES_CATEGORY1_ID]: [`${SECOND_HAND_PATH_PATTERN}buggy/`, '/nuevas/buggy/'],
  [MINIMOTOS_CATEGORY1_ID]: [`${SECOND_HAND_PATH_PATTERN}minimotos/`, '/nuevas/minimotos/'],
  [CLASSICS_CATEGORY1_ID]: [`${SECOND_HAND_PATH_PATTERN}clasicas/`]
}

export const ADS_LIST_FLATTENED_PATH_PATTERNS = [
  ...Object.values(ADS_LIST_PATH_PATTERNS).flat(Infinity),
  ADS_LIST_SUBSCRIPTION_PATH_PATTERN,
  ADS_LIST_SEARCH_PATH_PATTERN
]

export const ADS_LIST_PATH_PATTERNS_WITH_ALERTS_AVAILABLE = [...ADS_LIST_PATH_PATTERNS[MOTOS_CATEGORY1_ID]]

export const ADS_DETAIL_PATH_PATTERN = '/detail/:id/'
export const ADS_DETAIL_REGEX_PATH_PATTERN = /\/(ocasion|nuevas)\/.*-(?<adId>\d{5,8})\.htm(\?.*)?$/
export const ADS_DETAIL_PREVIEW_PATH_PATTERN = '/preview/:id'

export const PROFESSIONAL_STOCK_PATH = '/concesionario'
export const PROFESSIONAL_STOCK_PATH_PATTERN = `${PROFESSIONAL_STOCK_PATH}/:dealer/:section?/`
export const PROFESSIONAL_STOCK_RENTING_PATH_PATTERN = `${ADS_LIST_SUBSCRIPTION_PATH_PATTERN}concesionario/:dealer/:section?/`
export const PROFESSIONAL_STOCK_RENTING_WITH_REGEX =
  /^\/renting\/concesionario\/(?<dealerSlug>[A-Za-z0-9\-&]*)(\/(opiniones|informacion))?\/?$/

export const PROFESSIONAL_STOCK_WITH_ID_REGEX =
  /^\/concesionario\/(?<contractId>[A-Za-z0-9\-&]*)(\/(opiniones|informacion))?\/?$/

export const DEALERS_LIST_PATH = '/concesionarios/'
export const DEALERS_LIST_PATH_PATTERN = `${DEALERS_LIST_PATH}${WILDCARD_MARK}`

export const NEWS_CATEGORY_PATH_PATTERN = '/noticias/:category/'
export const NEWS_CATEGORY_REGEX_PATH_PATTERN =
  /(\/noticias(\/)*$)|(?<category>(\/noticias\/((?=novedades|videos|pruebas|actualidad|reportajes|[\\?&]([^&=]+)=([^&=]+)).+)))/
export const NEWS_HOME_PATH_PATTERN = '/noticias/'
export const NEWS_SEARCH_PATH_PATTERN = `/noticias/${QUESTION_MARK}${QUERY_SEARCH_PATTERN}:tag`
export const NEWS_SECTION_TIPS_PATH_PATTERN = '/consejos/'
export const NEWS_SECTION_TRENDS_PATH_PATTERN = '/tendencias/'
export const NEWS_TAG_PATH_PATTERN = `/noticias/t/:tag/`
export const NEWS_TAG_REGEX_PATH_PATTERN = /\/noticias\/t\/(?<tag>[^/]+)\/?/
export const NEWS_DETAIL_REGEX_PATH_PATTERN =
  /(\/noticias\/(?<slug1>((?!((novedades|videos|pruebas|actualidad|reportajes|t)\/|[\\?&]([^&=]+)=([^&=]+))).+))|(\/(videos|tendencias|comparativas|consejos)\/(?<slug2>.+)))|(\/preview-news-detail\/.+)/

export const NEWS_COMMENTS_BASE_PATH = '/opiniones'
export const NEWS_COMMENTS_PATH_PATTERN = `${NEWS_COMMENTS_BASE_PATH}/:category/:slug/:optional1?/:optional2?/:optional3?/:optional4?`
export const LANDING_FORMALITIES_PATH_PATTERN = '/tramites-compra-venta-motos/'
export const LANDING_FORMALITIES_SECURITY_GUIDELINES_PATH_PATTERN = '/guia-seguridad-compra-venta-motos/'

export const USER_DISCOUNTS_PATH_PATTERN = '/user/discounts/'
export const USER_PROFILE_COMPLETE_PURCHASE_PATTERN = '/user/profile/complete/purchase'
export const USER_PROFILE_COMPLETE_RESERVATION_PATTERN = '/user/profile/complete/reservation'
export const USER_PROFILE_PATTERN = '/user/profile/'
export const USER_PROFILE_EDIT_PATTERN = '/user/profile/edit/'
export const USER_FAVORITE_ADS_PATH_PATTERN = '/user/favorites'
export const USER_FAVORITE_DEALERS_PATH_PATTERN = '/user/favorites/dealers'
export const USER_SAVED_SEARCHES_PATH_PATTERN = '/user/alerts/'
export const USER_ALERTS_MATCHES_PATH_PATTERN = '/user/alerts/:alertId/'
export const USER_MESSAGES_PATH_PATTERN = '/user/messages/'
export const CHECKOUT_PATH_PATTERN = '/checkout/'
export const CHECKOUT_URL = `${CHECKOUT_PATH_PATTERN}?adId=:adId&products=:products`
export const CHECKOUT_SUCCESS_PATH_PATTERN = '/checkout/success'
export const CHECKOUT_ERROR_PATH_PATTERN = '/checkout/error'
export const CHECKOUT_PENDING_PATH_PATTERN = '/checkout/pending'
export const CHECKOUT_ACTIVATION_ERROR_PATH_PATTERN = '/checkout/activation-error'
export const CHECKOUT_REFUND_ERROR_PATH_PATTERN = '/checkout/refund-error'
export const CHECKOUT_REQUEST_ERROR_PATH_PATTERN = '/checkout/request-error'
export const CHECKOUT_UNKNOWN_ERROR_PATH_PATTERN = '/checkout/unknown-error'
export const PAYMENT_AD_REQUEST_PATH_PATTERN = '/payment-ad'
export const MY_ADS_PATH_PATTERN = '/mis-anuncios'
export const PUBLISH_MY_AD_PATH_PATTERN = '/publicar-mi-anuncio'
export const PUBLISH_MY_AD_CATEGORY_PATH_PATTERN = '/publicar-mi-anuncio/categoria'
export const EDIT_MY_AD_PATH_PATTERN = '/editar-mi-anuncio'
export const EDIT_MY_AD_OTHER_CATEGORIES_PATH_PATTERN = '/GTA/ModAd.aspx'
export const PUBLISH_YOUR_VEHICLE_PATH_PATTERN = '/vender-mi-moto'
export const PUBLISH_YOUR_VEHICLE_PATH_PATTERNS = '/vender-mi-moto/:province'
export const RATING_PATH_PATTERN = '/rating/:tradeId/'
export const TECHNICAL_DETAILS_PATH_PATTERN = '/fichas_tecnicas/'
export const TECHNICAL_DETAILS_COMPARATOR_PATH_PATTERN = `${TECHNICAL_DETAILS_PATH_PATTERN}comparador/`
export const TECHNICAL_DETAILS_COMPARATOR_RESULTS_PATH_PATTERN = `${TECHNICAL_DETAILS_COMPARATOR_PATH_PATTERN}:vehicle1Id/:vehicle2Id?/`
export const TECHNICAL_DETAILS_SEARCH_PATH_PATTERN = `${TECHNICAL_DETAILS_PATH_PATTERN}buscador/`
export const TECHNICAL_DETAILS_SEARCH_RESULTS_PATH_PATTERN = `${TECHNICAL_DETAILS_SEARCH_PATH_PATTERN}${QUESTION_MARK}${WILDCARD_MARK}`
export const TECHNICAL_DETAILS_MAKE_PATH_PATTERN = `${TECHNICAL_DETAILS_PATH_PATTERN}:make/`
export const TECHNICAL_DETAILS_MODEL_PATH_PATTERN = `${TECHNICAL_DETAILS_MAKE_PATH_PATTERN}:model/`
export const TECHNICAL_DETAILS_VERSION_PATH_PATTERN = `${TECHNICAL_DETAILS_MODEL_PATH_PATTERN}:versionId/`
export const TECHNICAL_DETAILS_VEHICLE_PATH_PATTERN = `${TECHNICAL_DETAILS_VERSION_PATH_PATTERN}:vehicleId/`
export const TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PATH_PATTERN = `${TECHNICAL_DETAILS_MODEL_PATH_PATTERN}:vehicleId/`
export const TECHNICAL_DETAILS_BODY_TYPE_PATH_REGEX = /(?<bodyType>[a-z_]+)-(?<year>[0-9]{4})/

export const COMPARATOR_PATH_PATTERN = '/comparador/'

export const NET_PATH_PATTERN = '/assistant'

export const RECOMMENDATIONS_PATH_PATTERN = '/recommendations/'

export const ADS_LIST_MAKE_MODEL_KM0_PATH_PATTERN = '/nuevas/:make/:model/'
export const ADS_LIST_MAKE_MODEL_NEW_VEHICLE_PATH_PATTERN = ''
export const ADS_LIST_MAKE_MODEL_USED_PATH_PATTERN = '/segunda-mano/:make/:model/'

export const ADS_LIST_SUBSCRIPTION_MAKE_MODEL_RENTING_PATH_PATTERN = '/renting/:make/:model/'

export const WDYL_MAKE_MODEL_PATH_PATTERN = '/s/:make/:model'
export const MODEL_SIZES_PATH_PATTERN = '/s/medidas/:make/:model'
export const MODEL_SIZES_PATH_PATTERN_REGEX = /\/s\/medidas\/([^/]+)\/([^/]+)\/?/
export const MODEL_DETAIL_PATH_PATTERN = '/s/'
export const MODEL_DETAIL_INTERIOR_PATH_PATTERN = '/s/interior/:make/:model/'
export const MODEL_DETAIL_TRUNK_PATH_PATTERN = '/s/maletero/:make/:model/'

export const VEHICLE_CONFIGURATOR_PATH = '/configurador/'
export const VEHICLE_CONFIGURATOR_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}{:make{/:model}}`

export const MODEL_DETAIL_PATH_PATTERN_REGEX = /\/s\/([^/]+)\/([^/]+)\/?/
export const MODEL_DETAIL_INTERIOR_PATH_PATTERN_REGEX = /\/s\/interior\/([^/]+)\/([^/]+)\/?/
export const MODEL_DETAIL_TRUNK_PATH_PATTERN_REGEX = /\/s\/maletero\/([^/]+)\/([^/]+)\/?/

export const PROFESSIONALS_PATH_PATTERN = '/registro-profesionales'

export const CHECKOUT_PAGE_NAME = 'checkout'
export const CHECKOUT_SUCCESS_PAGE_NAME = 'checkout-success'
export const CHECKOUT_ERROR_PAGE_NAME = 'checkout-error'
export const CHECKOUT_PENDING_PAGE_NAME = 'checkout-pending'
export const CHECKOUT_ACTIVATION_ERROR_PAGE_NAME = 'checkout-activation-error'
export const CHECKOUT_REFUND_ERROR_PAGE_NAME = 'checkout-refund-error'
export const CHECKOUT_REQUEST_ERROR_PAGE_NAME = 'checkout-request-error'
export const CHECKOUT_UNKNOWN_ERROR_PAGE_NAME = 'checkout-unknown-error'

export const ADS_LIST_FILTERS_PAGE_NAME = 'ads-list-filters'
export const ADS_LIST_PAGE_NAME = 'ads-list'
export const ADS_LIST_SUBSCRIPTION_PAGE_NAME = 'ads-list-subscription'
export const ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME = 'ads-list-business-subscription'
export const ADS_DETAIL_PAGE_NAME = 'ads-detail'
export const ADS_DETAIL_GALLERY_PAGE_NAME = 'ads-detail-gallery'
export const ADS_DETAIL_PREVIEW_PAGE_NAME = 'ads-detail-preview'
export const ADS_LIST_BUGGIES_PAGE_NAME = 'ads-list-buggies'
export const ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME = 'ads-list-classic-and-competition'
export const ADS_LIST_MINIMOTOS_PAGE_NAME = 'ads-list-minimotos'
export const ADS_LIST_QUADS_PAGE_NAME = 'ads-list-quads'
export const ADS_LIST_NEW_PAGE_NAME = 'ads-list-new'
export const ADS_LIST_BUGGIES_NEW_PAGE_NAME = 'ads-list-buggies-new'
export const ADS_LIST_MINIMOTOS_NEW_PAGE_NAME = 'ads-list-minimotos-new'
export const ADS_LIST_QUADS_NEW_PAGE_NAME = 'ads-list-quads-new'
export const HOME_PAGE_NAME = 'home'
export const INSTANT_OFFER_SELL_TO_DEALER_PAGE_NAME = 'instant-offer-sell-to-dealer'
export const INSTANT_OFFER_STANDALONE_PAGE_NAME = 'instant-offer-standalone'
export const INSURANCE_PAGE_NAME = 'insurance'
export const LANDING_FORMALITIES_PAGE_NAME = 'landing-formalities'
export const LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME = 'landing-formalities-security-guidelines'
export const LOGIN_PAGE_NAME = 'login'
export const MAKE_PAGE_NAME = 'make'
export const MAKES_DISTRIBUTOR_PAGE_NAME = 'makes-distributor'
export const MODEL_DETAIL_PAGE_NAME = 'model-detail'
export const MODEL_DETAIL_INTERIOR_PAGE_NAME = 'model-detail-interior'
export const MODEL_DETAIL_TRUNK_PAGE_NAME = 'model-detail-trunk'
export const NEWS_CATEGORY_PAGE_NAME = 'news-category'
export const NEWS_SECTION_TIPS_PAGE_NAME = 'news-section-tips'
export const NEWS_SECTION_TRENDS_PAGE_NAME = 'news-section-trends'
export const NEWS_TAG_PAGE_NAME = 'news-tag'
export const NEWS_DETAIL_PAGE_NAME = 'news-detail'
export const NEWS_COMMENTS_PAGE_NAME = 'news-comments'
export const NEWS_SEARCH_PAGE_NAME = 'news-search'
export const OTHER_PARTNERS_PAGE_NAME = 'other-partners'
export const PAYMENT_AD_REQUEST_PAGE_NAME = 'payment-ad-request'
export const PRODUCTS_PAGE_NAME = 'products'
export const MY_ADS_PAGE_NAME = 'ad-management-my-ads'
export const PUBLISH_MY_AD_PAGE_NAME = 'publish-my-ad'
export const PUBLISH_MY_AD_CATEGORY_PAGE_NAME = 'publish-my-ad-category'
export const PUBLISH_YOUR_VEHICLE_PAGE_NAME = 'publish-your-vehicle'
export const EDIT_MY_AD_PAGE_NAME = 'edit-my-ad'
export const RATING_PAGE_NAME = 'rating'
export const COMPARADOR_PAGE_NAME = 'comparador'
export const NET_PAGE_NAME = 'net_assistant'
export const RECOMMENDATIONS_PAGE_NAME = 'recommendations'
export const MAKES_SIZES_DISTRIBUTOR_PAGE_NAME = 'makes-sizes-distributor'
export const TECHNICAL_DETAILS_HOME_PAGE_NAME = 'technical-details'
export const TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME = 'technical-details-comparator'
export const TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME = 'technical-details-comparator-results'
export const TECHNICAL_DETAILS_SEARCH_PAGE_NAME = 'technical-details-search'
export const TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME = 'technical-details-search-results'
export const TECHNICAL_DETAILS_MAKE_PAGE_NAME = 'technical-details-make'
export const TECHNICAL_DETAILS_MODEL_PAGE_NAME = 'technical-details-model'
export const TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME = 'technical-details-body-type'
export const TECHNICAL_DETAILS_VERSION_PAGE_NAME = 'technical-details-version'
export const TECHNICAL_DETAILS_VEHICLE_PAGE_NAME = 'technical-details-vehicle'
export const TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME = 'technical-details-vehicle-without-version'
export const TERMS_OF_SERVICE_PAGE_NAME = 'terms-of-service'
export const TRANSPARENCY_PAGE_NAME = 'transparency'
export const USER_DISCOUNTS_PAGE_NAME = 'user-discounts'
export const USER_PROFILE_PAGE_NAME = 'user-profile'
export const USER_PROFILE_EDIT_PAGE_NAME = 'user-profile-edit'
export const USER_SAVED_SEARCHES_PAGE_NAME = 'user-saved-searches'
export const USER_ALERTS_MATCHES_PAGE_NAME = 'user-alerts-matches'
export const USER_FAVORITE_ADS_PAGE_NAME = 'user-favorite-ads'
export const USER_FAVORITE_DEALERS_PAGE_NAME = 'user-favorite-dealers'
export const USER_MESSAGES_PAGE_NAME = 'user-messaging'
export const USER_ADS_PATH_PATTERN = '/mis-anuncios'
export const VEHICLE_CONFIGURATOR_PAGE_NAME = 'vehicle-configurator'
export const VEHICLES_GRID_PAGE_NAME = 'vehicles-grid'
export const PROFESSIONAL_STOCK_PAGE_NAME = 'professional-stock'
export const PROFESSIONAL_STOCK_RENTING_PAGE_NAME = 'professional-stock-renting'
export const DEALERS_LIST_PAGE_NAME = 'dealers-list'
export const PROFESSIONALS_PAGE_NAME = 'professionals'

export const ADS_LIST_PAGE_NAMES = [
  ADS_LIST_PAGE_NAME,
  ADS_LIST_BUGGIES_PAGE_NAME,
  ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
  ADS_LIST_MINIMOTOS_PAGE_NAME,
  ADS_LIST_QUADS_PAGE_NAME,
  ADS_LIST_NEW_PAGE_NAME,
  ADS_LIST_BUGGIES_NEW_PAGE_NAME,
  ADS_LIST_MINIMOTOS_NEW_PAGE_NAME,
  ADS_LIST_QUADS_NEW_PAGE_NAME
]

export const DISTRIBUTOR_PAGE_CONFIG = {
  [MAKES_DISTRIBUTOR_PAGE_NAME]: {
    literalPrefix: 'MAKES_DISTRIBUTOR',
    nextPagePattern: WDYL_MAKE_MODEL_PATH_PATTERN
  },
  [MAKES_SIZES_DISTRIBUTOR_PAGE_NAME]: {
    literalPrefix: 'MAKES_SIZES_DISTRIBUTOR',
    nextPagePattern: MODEL_SIZES_PATH_PATTERN
  }
}

export const PAGE_PATTERNS = {
  [ADS_LIST_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[MOTOS_CATEGORY1_ID][0]],
  [ADS_LIST_QUADS_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[QUADS_CATEGORY1_ID][0]],
  [ADS_LIST_BUGGIES_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[BUGGIES_CATEGORY1_ID][0]],
  [ADS_LIST_MINIMOTOS_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[MINIMOTOS_CATEGORY1_ID][0]],
  [ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[CLASSICS_CATEGORY1_ID][0]],
  [ADS_LIST_NEW_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[MOTOS_CATEGORY1_ID][1]],
  [ADS_LIST_QUADS_NEW_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[QUADS_CATEGORY1_ID][1]],
  [ADS_LIST_BUGGIES_NEW_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[BUGGIES_CATEGORY1_ID][1]],
  [ADS_LIST_MINIMOTOS_NEW_PAGE_NAME]: [ADS_LIST_PATH_PATTERNS[MINIMOTOS_CATEGORY1_ID][1]],
  [ADS_DETAIL_PAGE_NAME]: [ADS_DETAIL_PATH_PATTERN, ADS_DETAIL_REGEX_PATH_PATTERN],
  [ADS_DETAIL_PREVIEW_PAGE_NAME]: [ADS_DETAIL_PREVIEW_PATH_PATTERN],
  [PROFESSIONAL_STOCK_PAGE_NAME]: [PROFESSIONAL_STOCK_PATH_PATTERN],
  [PROFESSIONAL_STOCK_RENTING_PAGE_NAME]: [PROFESSIONAL_STOCK_RENTING_PATH_PATTERN],
  [DEALERS_LIST_PAGE_NAME]: [DEALERS_LIST_PATH_PATTERN],
  [HOME_PAGE_NAME]: [HOME_PATH_PATTERN, AB_HOME_PATH_PATTERN],
  [INSTANT_OFFER_STANDALONE_PAGE_NAME]: [INSTANT_OFFER_STANDALONE_PATTERN],
  [INSTANT_OFFER_SELL_TO_DEALER_PAGE_NAME]: [INSTANT_OFFER_SELL_TO_DEALER_PATTERN],
  [INSURANCE_PAGE_NAME]: [INSURANCE_PATH],
  [LANDING_FORMALITIES_PAGE_NAME]: [LANDING_FORMALITIES_PATH_PATTERN],
  [LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME]: [LANDING_FORMALITIES_SECURITY_GUIDELINES_PATH_PATTERN],
  [NEWS_SEARCH_PAGE_NAME]: [NEWS_SEARCH_PATH_PATTERN],
  [NEWS_TAG_PAGE_NAME]: [NEWS_TAG_PATH_PATTERN, NEWS_TAG_REGEX_PATH_PATTERN],
  // Note: details paths need to be defined before categories to avoid matching "/noticias/videos-de-motos" as news category listings because of "/noticias/videos" rule
  [NEWS_COMMENTS_PAGE_NAME]: [NEWS_COMMENTS_PATH_PATTERN],
  [NEWS_DETAIL_PAGE_NAME]: [NEWS_DETAIL_REGEX_PATH_PATTERN],
  [NEWS_CATEGORY_PAGE_NAME]: [NEWS_CATEGORY_REGEX_PATH_PATTERN],
  [NEWS_SECTION_TIPS_PAGE_NAME]: [NEWS_SECTION_TIPS_PATH_PATTERN],
  [NEWS_SECTION_TRENDS_PAGE_NAME]: [NEWS_SECTION_TRENDS_PATH_PATTERN],
  [LOGIN_PAGE_NAME]: [LOGIN_PATH_PATTERN, AB_LOGIN_PATH_PATTERN],
  [TERMS_OF_SERVICE_PAGE_NAME]: [TERMS_OF_SERVICE_PATH_PATTERN],
  [TRANSPARENCY_PAGE_NAME]: [TRANSPARENCY_PATH_PATTERN],
  [OTHER_PARTNERS_PAGE_NAME]: [OTHER_PARTNERS_PATH_PATTERN],
  [COMPARADOR_PAGE_NAME]: [COMPARATOR_PATH_PATTERN],
  [NET_PAGE_NAME]: [NET_PATH_PATTERN],
  [RECOMMENDATIONS_PAGE_NAME]: [RECOMMENDATIONS_PATH_PATTERN],
  [USER_DISCOUNTS_PAGE_NAME]: [USER_DISCOUNTS_PATH_PATTERN],
  [USER_PROFILE_PAGE_NAME]: [USER_PROFILE_PATTERN],
  [USER_PROFILE_EDIT_PAGE_NAME]: [USER_PROFILE_EDIT_PATTERN],
  [USER_SAVED_SEARCHES_PAGE_NAME]: [USER_SAVED_SEARCHES_PATH_PATTERN],
  [USER_ALERTS_MATCHES_PAGE_NAME]: [USER_ALERTS_MATCHES_PATH_PATTERN],
  [USER_FAVORITE_ADS_PAGE_NAME]: [USER_FAVORITE_ADS_PATH_PATTERN],
  [USER_FAVORITE_DEALERS_PAGE_NAME]: [USER_FAVORITE_DEALERS_PATH_PATTERN],
  [USER_MESSAGES_PAGE_NAME]: [USER_MESSAGES_PATH_PATTERN],
  [CHECKOUT_PAGE_NAME]: [CHECKOUT_PATH_PATTERN],
  [CHECKOUT_SUCCESS_PAGE_NAME]: [CHECKOUT_SUCCESS_PATH_PATTERN],
  [CHECKOUT_ERROR_PAGE_NAME]: [CHECKOUT_ERROR_PATH_PATTERN],
  [CHECKOUT_PENDING_PAGE_NAME]: [CHECKOUT_PENDING_PATH_PATTERN],
  [CHECKOUT_ACTIVATION_ERROR_PAGE_NAME]: [CHECKOUT_ACTIVATION_ERROR_PATH_PATTERN],
  [CHECKOUT_REFUND_ERROR_PAGE_NAME]: [CHECKOUT_REFUND_ERROR_PATH_PATTERN],
  [CHECKOUT_REQUEST_ERROR_PAGE_NAME]: [CHECKOUT_REQUEST_ERROR_PATH_PATTERN],
  [CHECKOUT_UNKNOWN_ERROR_PAGE_NAME]: [CHECKOUT_UNKNOWN_ERROR_PATH_PATTERN],
  [PRODUCTS_PAGE_NAME]: [PRODUCTS_PATH_PATTERN],
  [PAYMENT_AD_REQUEST_PAGE_NAME]: [PAYMENT_AD_REQUEST_PATH_PATTERN],
  [PROFESSIONALS_PAGE_NAME]: [PROFESSIONALS_PATH_PATTERN],
  [MY_ADS_PAGE_NAME]: [MY_ADS_PATH_PATTERN],
  [PUBLISH_MY_AD_PAGE_NAME]: [PUBLISH_MY_AD_PATH_PATTERN],
  [PUBLISH_MY_AD_CATEGORY_PAGE_NAME]: [PUBLISH_MY_AD_CATEGORY_PATH_PATTERN],
  [PUBLISH_YOUR_VEHICLE_PAGE_NAME]: [PUBLISH_YOUR_VEHICLE_PATH_PATTERN],
  [EDIT_MY_AD_PAGE_NAME]: [EDIT_MY_AD_PATH_PATTERN],
  [RATING_PAGE_NAME]: [RATING_PATH_PATTERN],
  [TECHNICAL_DETAILS_HOME_PAGE_NAME]: [TECHNICAL_DETAILS_PATH_PATTERN],
  [TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME]: [TECHNICAL_DETAILS_COMPARATOR_PATH_PATTERN],
  [TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME]: [TECHNICAL_DETAILS_COMPARATOR_RESULTS_PATH_PATTERN],
  [TECHNICAL_DETAILS_SEARCH_PAGE_NAME]: [TECHNICAL_DETAILS_SEARCH_PATH_PATTERN],
  [TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME]: [TECHNICAL_DETAILS_SEARCH_RESULTS_PATH_PATTERN],
  [TECHNICAL_DETAILS_MAKE_PAGE_NAME]: [TECHNICAL_DETAILS_MAKE_PATH_PATTERN],
  [TECHNICAL_DETAILS_MODEL_PAGE_NAME]: [TECHNICAL_DETAILS_MODEL_PATH_PATTERN],
  [TECHNICAL_DETAILS_VEHICLE_PAGE_NAME]: [TECHNICAL_DETAILS_VEHICLE_PATH_PATTERN],
  [TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME]: [TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PATH_PATTERN]
}

/**
 * We can not have patterns with route params
 */
export const PAGES_WITHOUT_ADS = [
  CHECKOUT_ACTIVATION_ERROR_PATH_PATTERN,
  CHECKOUT_ERROR_PATH_PATTERN,
  CHECKOUT_PATH_PATTERN,
  CHECKOUT_PENDING_PATH_PATTERN,
  CHECKOUT_REFUND_ERROR_PATH_PATTERN,
  CHECKOUT_REQUEST_ERROR_PATH_PATTERN,
  CHECKOUT_SUCCESS_PATH_PATTERN,
  CHECKOUT_UNKNOWN_ERROR_PATH_PATTERN,
  INSTANT_OFFER_SELL_TO_DEALER_PATTERN,
  INSTANT_OFFER_STANDALONE_PATTERN,
  INSURANCE_PATH,
  LOGIN_PATH_PATTERN,
  MOBILE_PAGES_PATH_PATTERN,
  OTHER_PARTNERS_PATH_PATTERN,
  PAYMENT_AD_REQUEST_PATH_PATTERN,
  PRODUCTS_PATH_PATTERN,
  PROFESSIONALS_PATH_PATTERN,
  PROFESSIONAL_STOCK_WITH_ID_REGEX,
  PROFESSIONAL_STOCK_RENTING_WITH_REGEX,
  MY_ADS_PATH_PATTERN,
  PUBLISH_MY_AD_PATH_PATTERN,
  PUBLISH_MY_AD_CATEGORY_PATH_PATTERN,
  PUBLISH_YOUR_VEHICLE_PATH_PATTERN,
  PUBLISH_YOUR_VEHICLE_PATH_PATTERNS,
  EDIT_MY_AD_PATH_PATTERN,
  EDIT_MY_AD_OTHER_CATEGORIES_PATH_PATTERN,
  RATING_PATH_PATTERN,
  COMPARATOR_PATH_PATTERN,
  NET_PATH_PATTERN,
  RECOMMENDATIONS_PATH_PATTERN,
  TERMS_OF_SERVICE_PATH_PATTERN,
  USER_ALERTS_MATCHES_PATH_PATTERN,
  USER_DISCOUNTS_PATH_PATTERN,
  USER_FAVORITE_ADS_PATH_PATTERN,
  USER_FAVORITE_DEALERS_PATH_PATTERN,
  USER_MESSAGES_PATH_PATTERN,
  USER_PROFILE_EDIT_PATTERN,
  USER_PROFILE_PATTERN,
  USER_SAVED_SEARCHES_PATH_PATTERN
]

export const CAPTCHA_ORIGINS = {
  AD_DETAIL_CONTACT: 'AdDetailContact',
  MODEL_DETAIL_CONTACT: 'ModelDetailContact'
}

export const CAPTCHA_ORIGINS_BY_PAGENAME = {
  [ADS_DETAIL_PAGE_NAME]: CAPTCHA_ORIGINS.AD_DETAIL_CONTACT,
  [MODEL_DETAIL_PAGE_NAME]: CAPTCHA_ORIGINS.MODEL_DETAIL_CONTACT,
  [PROFESSIONAL_STOCK_PAGE_NAME]: CAPTCHA_ORIGINS.AD_DETAIL_CONTACT
}

export const MODEL_DETAIL_DEALERSHIP_CONTEXT = 'ModelDetailDealershipContext'
export const MODEL_DETAIL_OEM_CONTEXT = 'ModelDetailOEMContext'

export const CAPTCHA_ORIGINS_BY_CONTEXT = {
  [MODEL_DETAIL_DEALERSHIP_CONTEXT]: CAPTCHA_ORIGINS.AD_DETAIL_CONTACT,
  [MODEL_DETAIL_OEM_CONTEXT]: CAPTCHA_ORIGINS.MODEL_DETAIL_CONTACT
}

export const PAGES_WITH_PRICE_DROP = []

// Define only the paths that are different from the common ones
export const PAGE_NAMES_BY_LISTING_SECTION_ID = {...sharedPageNamesByListingSectionId}

export const DEALER_RATING_STEP_PAGE_NAMES = {
  0: 'DEALER_RATING_STEP_0',
  1: 'DEALER_RATING_STEP_1',
  2: 'DEALER_RATING_STEP_2',
  3: 'DEALER_RATING_STEP_3'
}

export const DEALER_RATING_STATE_PAGE_NAMES = {
  CLOSED: 'DEALER_RATING_STATE_CLOSED',
  EXPIRED: 'DEALER_RATING_STATE_EXPIRED',
  SUCCESS: 'DEALER_RATING_STATE_SUCCESS'
}

export const AD_DETAIL_RESERVATION_HASHES = sharedAdDetailReservationHashes
